import {expenseReviewStatusConstants} from '../../constants';

// Display-only key: the stored status stays `partially_approved`. The To Reclaim tab (and a
// details panel opened from it) shows it, because the company is taking part of the money back.
export const PARTIALLY_REJECTED_DISPLAY_KEY = 'partially_rejected';

/**
 * Picks which entry of `expenseReviewStatuses` a status is displayed with.
 * Only `partially_approved` changes, and only in a reclaim context; every other status is
 * returned as given. Kept free of JSX and component imports so it can be unit tested.
 * @param {string} status - Stored review status.
 * @param {boolean} [isReclaimContext] - True when shown from the To Reclaim tab.
 * @returns {string} Key into `expenseReviewStatuses`.
 * @example
 * getReviewStatusDisplayKey('partially_approved', true); // 'partially_rejected'
 */
export const getReviewStatusDisplayKey = (status, isReclaimContext = false) => {
  if (isReclaimContext && status === expenseReviewStatusConstants.PARTIALLY_APPROVED) {
    return PARTIALLY_REJECTED_DISPLAY_KEY;
  }
  return status;
};
